/**
 * PrivacySLPrivacyPageView
 *
 * Page component for PrivacySLPrivacyPageView
 * Path: /sl/privacy
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PrivacySLPrivacyPageView as __PrivacySLPrivacyPageView } from '@/components/traits/PrivacySLPrivacyPageView';
import { PrivacySLPrivacyAnalyticsView as __PrivacySLPrivacyAnalyticsView } from '@/components/traits/PrivacySLPrivacyAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface PrivacySLPrivacyPageViewProps {
  // Add any page-level props here
}

export function PrivacySLPrivacyPageView(_props: PrivacySLPrivacyPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-privacy:meta.title"],"description":["i18n/t","std-almadar-privacy:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/privacy"},{"locale":"ar","path":"/ar/privacy"},{"locale":"sl","path":"/sl/privacy"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PrivacySLPrivacyPageView config={{ initPayload: __navState }} />
          <__PrivacySLPrivacyAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default PrivacySLPrivacyPageView;
